import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col" }

import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import SubSection from "../common/SubSection.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrigenAdvice',
  setup(__props) {

const store = useStore();
const display = ref(false);

onMounted(() => {
    display.value = store.state.configuration.finishDisplaysFinancialAdvice;
});


return (_ctx: any,_cache: any) => {
  return (display.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SubSection, {
            title: "Do you need financial advice?",
            "show-help": false
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("p", null, " This model is for information only. Call us for an initial meeting at our expense to discuss your plans and start saving for a brighter financial future. ", -1),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, "Call:     "),
                _createTextVNode(" 0800 068 8214    "),
                _createElementVNode("small", { class: "text-muted" }, "All calls are recorded for business purposes")
              ], -1),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, "Email:  "),
                _createTextVNode(),
                _createElementVNode("a", { href: "mailto:clientservices@origenfs.co.uk" }, "clientservices@origenfs.co.uk")
              ], -1),
              _createElementVNode("p", null, " Origen is one of the UK's leading national financial advisers, with a history of providing advice for 140 years. We support people like you every day and we have advisers across the UK who are here to help you. Our advice is based on your own personal circumstances, aspirations and financial objectives. ", -1),
              _createElementVNode("p", null, [
                _createElementVNode("img", {
                  src: "/Content/images/origen/origen-award-strip.png",
                  class: "img-responsive",
                  alt: "Origen Awards",
                  style: {"width":"75%"}
                })
              ], -1)
            ])),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})